import { render, staticRenderFns } from "./AgeAnalysisReport.vue?vue&type=template&id=13fe4ebc&scoped=true"
import script from "./AgeAnalysisReport.vue?vue&type=script&lang=js"
export * from "./AgeAnalysisReport.vue?vue&type=script&lang=js"
import style0 from "./AgeAnalysisReport.vue?vue&type=style&index=0&id=13fe4ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fe4ebc",
  null
  
)

export default component.exports